export class ShowLangSelector {
  static readonly type = '[LANGSELECTOR] Show';
}

export class HideLangSelector {
  static readonly type = '[LANGSELECTOR] Hide';
}
